import React from 'react';
import { OpsSubnav } from '../ops/OpsPanelChrome';
import type { GainsMonitorView } from '../GainsMonitorDashboard';

const VIEWS: Array<{ id: GainsMonitorView; label: string }> = [
  { id: 'overview', label: 'Visão Geral' },
  { id: 'trends', label: 'Tendências' },
  { id: 'roi', label: 'ROI' },
  { id: 'alerts', label: 'Alertas' },
];

export const GainsPageHeader: React.FC<{
  view: GainsMonitorView;
  onViewChange: (view: GainsMonitorView) => void;
}> = ({ view, onViewChange }) => (
  <div className="shrink-0 px-3">
    <OpsSubnav items={VIEWS} value={view} onChange={onViewChange} />
  </div>
);
